'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_components_RecipeViewer$State(scaleValue, printNutrition) {
  this.uH = null;
  this.uG = false;
  this.uH = scaleValue;
  this.uG = printNutrition;
}
export { $c_Lmealorama_components_RecipeViewer$State as $c_Lmealorama_components_RecipeViewer$State };
$p = $c_Lmealorama_components_RecipeViewer$State.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_components_RecipeViewer$State;
/** @constructor */
function $h_Lmealorama_components_RecipeViewer$State() {
}
export { $h_Lmealorama_components_RecipeViewer$State as $h_Lmealorama_components_RecipeViewer$State };
$h_Lmealorama_components_RecipeViewer$State.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, 80204913);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.uH));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, (this.uG ? 1231 : 1237));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().ax(acc, 2);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_components_RecipeViewer$State)) {
    if ((this.uG === x$0.uG)) {
      var x = this.uH;
      var x$2 = x$0.uH;
      return ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 2;
});
$p.r = (function() {
  return "State";
});
$p.g = (function(n) {
  if ((n === 0)) {
    return this.uH;
  }
  if ((n === 1)) {
    return this.uG;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
});
function $isArrayOf_Lmealorama_components_RecipeViewer$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kk)));
}
export { $isArrayOf_Lmealorama_components_RecipeViewer$State as $isArrayOf_Lmealorama_components_RecipeViewer$State };
var $d_Lmealorama_components_RecipeViewer$State = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_components_RecipeViewer$State, "mealorama.components.RecipeViewer$State", ({
  kk: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_components_RecipeViewer$State as $d_Lmealorama_components_RecipeViewer$State };
//# sourceMappingURL=mealorama.components.-Recipe-Viewer$-State.js.map
